import { render } from "./FulfillmentStatusLabel.vue?vue&type=template&id=055cfdf6"
import script from "./FulfillmentStatusLabel.vue?vue&type=script&lang=js"
export * from "./FulfillmentStatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__